import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        prime: "#2b2b44",
        gray0: "#A5A5A5",
        accent: "#82B1FF",
        orange: "#f9a600",
        error: "#FF5252",
        gray1: "#727272",
        success: "#4CAF50",
        warning: "#FFC107",
        white: "#ffffff",
        blue: "#2272b1",
        blueLight: "#F6F6F6",
        blueLight2: "#90A9A9",
        gray2: "#EAEAEA",
        bordo: "#A53D3D",
      },
    },
  },
  themes: {
    light: {
      prime: "#2b2b44",
      gray0: "#A5A5A5",
      accent: "#82B1FF",
      orange: "#f9a600",
      error: "#FF5252",
      gray1: "#727272",
      success: "#4CAF50",
      warning: "#FFC107",
      white: "#ffffff",
      blue: "#2272b1",
      blueLight: "#F6F6F6",
      blueLight2: "#90A9A9",
      gray2: "#EAEAEA",
      bordo: "#A53D3D",
    },
  },
});
